window.lodash = require('lodash');

(function() {

    if( window.sessionStorage === undefined) {
        return;
    }

    let funnelStage;

    try {
        if (sessionStorage.getItem('funnelStage')) {
            funnelStage = JSON.parse(window.sessionStorage.getItem('funnelStage'));
        }
    } catch (error) {
        // Reset funnelStage
    }

    if (_.isEmpty(funnelStage)) {
        funnelStage = {
            'visited_website': false,
            'visited_garage_page': false,
            'opened_appointment_modal': false,
            'appointment_reached_step_two': false,
            'appointment_modal_completed': false
        }
    }

    window.dataLayer = window.dataLayer || [];

    // visited website
    if (funnelStage.visited_website !== true) {
        window.dataLayer.push({
            'event': 'visited-website'
        });

        updateFunnelStage('visited_website', true);
    }

    // Visited Garage pagina main
    let onGaragePage = window.location.href.includes('/vestiging/');
    let onGarageMainPage = document.querySelector('body').classList.contains('path-garage');

    if (funnelStage.visited_garage_page !== true && onGaragePage && onGarageMainPage) {
        window.dataLayer.push({
            'event': 'visited-garage-page'
        });

        updateFunnelStage('visited_garage_page', true);
    }

    Drupal.behaviors.afspraakMakenModal = {
        attach: function (context, settings) {

            // opened appointment modal
            jQuery(once('webform-submission-afspraak-maken-form', 'form.webform-submission-afspraak-maken-form', context)).each(function () {
                if (funnelStage.opened_appointment_modal !== true) {
                    window.dataLayer.push({
                        'event': 'opened-appointment-modal'
                    });

                    updateFunnelStage('opened_appointment_modal', true);
                }
            });

            // Appointment modal reached step 2
            jQuery(once('webform-progress-step-2-active', 'div.webform-progress ul li[data-webform-page="stap_2"].is-active', context)).each(function () {
                if (funnelStage.appointment_reached_step_two !== true && funnelStage.opened_appointment_modal === true) {
                    window.dataLayer.push({
                        'event': 'appointment-reached-step-two'
                    });

                    updateFunnelStage('appointment_reached_step_two', true);
                }
            });

            // Appointment modal reached end
            jQuery(once('webform-progress-webform-confirmation', 'div.webform-progress ul li[data-webform-page="webform_confirmation"].is-active', context)).each(function () {
                if (funnelStage.appointment_modal_completed !== true && funnelStage.appointment_reached_step_two === true) {
                    window.dataLayer.push({
                        'event': 'appointment-modal-completed'
                    });

                    updateFunnelStage('appointment_modal_completed', true);
                }
            });
        }
    };

    function updateFunnelStage(key, value) {
        funnelStage[key] = value;

        sessionStorage.setItem('funnelStage', JSON.stringify(funnelStage));
    }
})();